import { Skeleton, styled } from '@mui/material';

export const Container = styled(Skeleton)`
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    border-radius: 8px;
`;
